<template>
  <DeepDialog
    v-model="globalStore.documentDialog"
    fullscreen-on-mobile
    :title="title"
    width="600"
    @click:outside.prevent="globalStore.documentDialogState = null"
    @keydown.esc="() => (globalStore.documentDialogState = null)"
  >
    <template #content>
      <ForwardForm
        v-if="globalStore.documentDialogState === 'forward'"
        @close-dialog="closeDialog"
      />
      <InviteForm
        v-if="globalStore.documentDialogState === 'invite'"
        @close-dialog="closeDialog"
      />
      <RemoveSigneeCard
        v-if="globalStore.documentDialogState === 'remove-signee'"
        @close-dialog="closeDialog"
      />
      <RemoveApproverCard
        v-if="globalStore.documentDialogState === 'remove-approver'"
        @close-dialog="closeDialog"
      />
      <UpdateEmailForm
        v-if="globalStore.documentDialogState === 'edit'"
        @close-dialog="closeDialog"
      />
      <ObserverForm
        v-if="globalStore.documentDialogState === 'add-observer'"
        @close-dialog="closeDialog"
      />
      <RemoveObserverCard
        v-if="globalStore.documentDialogState === 'remove-observer'"
        @close-dialog="closeDialog"
      />
    </template>

    <template #actions>
      <portal-target name="document-dialog-actions"></portal-target>
    </template>
  </DeepDialog>
</template>

<script setup lang="ts">
import UpdateEmailForm from '@/components/dialogs/document-dialog/UpdateEmailForm.vue';
import RemoveSigneeCard from '@/components/dialogs/document-dialog/RemoveSigneeCard.vue';
import RemoveObserverCard from '@/components/dialogs/document-dialog/RemoveObserverCard.vue';
import RemoveApproverCard from '@/components/cards/approver/RemoveApproverCard.vue';
import ObserverForm from '@/components/dialogs/document-dialog/ObserverForm.vue';
import InviteForm from '@/components/dialogs/document-dialog/InviteForm.vue';
import ForwardForm from '@/components/dialogs/document-dialog/ForwardForm.vue';
import { useGlobalStore } from '@/stores/global.ts';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { DeepDialog } from '@deepcloud/deep-ui-lib';
import { PortalTarget } from 'portal-vue';

const i18n = useI18n();

const globalStore = useGlobalStore();

function closeDialog() {
  globalStore.documentDialog = false;
}

// Title
const title = computed(() => {
  switch (globalStore.documentDialogState) {
    case 'invite':
      return i18n.t('dialogs.document_dialog.titles.invite_signee');
    case 'forward':
      return i18n.t('dialogs.document_dialog.titles.forward_document');
    case 'remove-signee':
      return i18n.t('dialogs.document_dialog.titles.remove_signee');
    case 'remove-approver':
      return i18n.t('dialogs.document_dialog.titles.remove_approver');
    case 'edit':
      return i18n.t('dialogs.document_dialog.titles.edit_email');
    case 'add-observer':
      return i18n.t('dialogs.document_dialog.titles.add_observer');
    case 'remove-observer':
      return i18n.t('dialogs.document_dialog.titles.remove_observer');
    default:
      return '';
  }
});
</script>
